import { render, staticRenderFns } from "./OrderActivity.vue?vue&type=template&id=886b6f6c&lang=pug"
import script from "./OrderActivity.vue?vue&type=script&lang=js"
export * from "./OrderActivity.vue?vue&type=script&lang=js"
import style0 from "./OrderActivity.vue?vue&type=style&index=0&id=886b6f6c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports